import { useSearchParams } from '@solidjs/router';

import { getTypeOptions } from '../types';

/**
 * Vertical tab list for transaction record `type` — same URL semantics as {@link TransactionType}.
 */
export default function TransactionTypeSidebar(props: { class?: string }) {
  const [searchParams, setSearchParams] = useSearchParams();

  const options = createMemo(() => getTypeOptions());

  const currentValue = () => (searchParams['type'] as string | undefined) ?? '';

  return (
    <nav
      class={cx(
        'flex shrink-0 flex-col gap-1 rounded-lg bg-layer5 p-2',
        'w-full max-h-[min(70vh,464px)] overflow-y-auto sm:w-[250px]',
        props.class
      )}
      aria-label={t('Transaction type')}
    >
      <For each={options()}>
        {(item) => {
          const active = () => currentValue() === (item.value ?? '');
          return (
            <button
              type="button"
              class={cx(
                'rounded-md px-3 py-2.5 text-left text-neutral-main1 caption-l-semibold transition-colors',
                active() ? 'bg-tab-bg-active' : 'hover:bg-layer5_5-card'
              )}
              onClick={() => setSearchParams({ ...searchParams, type: item.value, page: 1 }, { replace: true })}
            >
              {item.label()}
            </button>
          );
        }}
      </For>
    </nav>
  );
}
